import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d02895"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel-controls" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { onMounted, ref, watch } from "vue";
import { useResizeObserver, useScroll } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCarouselControls',
  props: {
  carouselId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;


let carouselEl = ref<HTMLElement>();
const scrollTrack = ref<HTMLElement>();
const scrollThumb = ref<HTMLElement>();
onMounted(() => {
  carouselEl.value = document.getElementById(props.carouselId) as HTMLElement;
});
const { x } = useScroll(carouselEl);
watch(x, (currVal) => {
  calcBar(currVal);
});

const calcBar = (currVal: number) => {
  if (carouselEl.value && scrollThumb.value && scrollTrack.value) {
    const trackWidth = scrollTrack.value.clientWidth;
    const thumbWidth = scrollThumb.value.clientWidth;
    const scrollWidth = carouselEl.value.scrollWidth;
    const clientWidth = carouselEl.value.clientWidth;
    const percentage = currVal / (scrollWidth - clientWidth);
    const val = (trackWidth - thumbWidth) * (currVal / (scrollWidth - clientWidth));
    scrollThumb.value.style.left = `${val}px`;
    hasPrev.value = percentage !== 0;
    hasNext.value = percentage !== 1;
  }
};
useResizeObserver(document.querySelector("body"), () => {
  onResize();
});
const onResize = () => {
  const el = carouselEl.value as HTMLElement;
  showControls.value = el && el.scrollWidth > el.clientWidth;
  calcBar(x.value);
};
const showControls = ref<boolean>(false);
const onPreviousClick = () => {
  const outsideEl = getPrev();
  if (outsideEl) {
    outsideEl.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
  }
};
const onNextClick = () => {
  const outsideEl = getNext();
  if (outsideEl) {
    outsideEl.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "end" });
  }
};
const getPrev = () => {
  if (carouselEl.value) {
    const distanceFromLeft = carouselEl.value.getBoundingClientRect().x;
    const children = [...carouselEl.value.children].reverse();
    const outsideEl = children.find((x) => {
      const clientRect = x.getBoundingClientRect();
      if (Math.ceil(clientRect.x - distanceFromLeft) < 0) {
        return x;
      }
    });
    return outsideEl;
  }
  return null;
};
const getNext = () => {
  if (carouselEl.value) {
    const distanceFromLeft = carouselEl.value.getBoundingClientRect().x;
    const viewportWidth = carouselEl.value.clientWidth;
    const children = [...carouselEl.value.children];
    const outsideEl = children.find((x) => {
      const clientRect = x.getBoundingClientRect();
      if (clientRect.x + clientRect.width - distanceFromLeft > viewportWidth + 1) {
        return x;
      }
    });
    return outsideEl;
  }
  return null;
};
const hasPrev = ref<boolean>(false);
const hasNext = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  const _component_icon_arrow_left = _resolveComponent("icon-arrow-left")!
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: onPreviousClick,
      class: "carousel-controls__prev-button",
      disabled: !hasPrev.value,
      "aria-label": "previous"
    }, [
      _createVNode(_component_icon_arrow_left, { class: "carousel-controls__arrow" })
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: "carousel-controls__scroll__bar",
      ref_key: "scrollTrack",
      ref: scrollTrack
    }, [
      _createElementVNode("div", {
        class: "carousel-controls__scroll__thumb",
        ref_key: "scrollThumb",
        ref: scrollThumb
      }, null, 512)
    ], 512),
    _createElementVNode("button", {
      onClick: onNextClick,
      class: "carousel-controls__next-button",
      disabled: !hasNext.value,
      "aria-label": "next"
    }, [
      _createVNode(_component_icon_arrow_right, { class: "carousel-controls__arrow" })
    ], 8, _hoisted_3)
  ], 512)), [
    [_vShow, showControls.value]
  ])
}
}

})